import { frontendURL } from 'dashboard/helper/URLHelper';

const TrainingVideosIndex = () => import('./TrainingVideosIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/training'),
      name: 'training_videos_index',
      component: TrainingVideosIndex,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
    },
  ],
};
